import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { getFileUrl } from "@/lib/pocketbase";

type StreakStarsProps = {
  streakNumber: number;
  name: string;
  id: string;
  avatar?: string;
};

const StreakStars = ({ streakNumber, name, id, avatar }: StreakStarsProps) => {
  const [limit, setLimit] = useState(0);
  useEffect(() => {
    isMobile ? setLimit(50) : setLimit(100);
  }, [isMobile]);

  return (
    <div
      className="flex flex-col lg:flex-row lg:items-center font-bold mb-4"
      id={id}
    >
      {/* Avatar */}
      <div className="w-8 h-8 rounded-full overflow-hidden bg-gradient-to-br from-primary to-secondary flex items-center justify-center me-2 flex-shrink-0">
        {avatar ? (
          <img
            src={getFileUrl("users", id, avatar)}
            alt={name}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-white text-sm font-bold">
            {name?.charAt(0)?.toUpperCase() || "?"}
          </span>
        )}
      </div>
      <span className="me-3">{name}</span>
      <div className="streakstars-bar me-3">
        {Array.from({ length: Math.min(streakNumber, limit) }).map((_, i) => (
          <span key={i}>|</span>
        ))}
      </div>
      <span>{streakNumber} Days</span>
    </div>
  );
};
export default StreakStars;
